import { DynamicGalleryRouting } from '@aipb/gulliver/dynamic-gallery/routing';
import { Routes } from '@angular/router';
import { DynamicGalleryInitGuard } from './dynamic-gallery-init.guard';
import { EntryComponent } from './entry/entry.component';

export const DynamicGalleryRoutes: Routes = [
  {
    path: '',
    redirectTo: 'default',
    pathMatch: 'prefix'
  },
  {
    path: DynamicGalleryRouting.configPath,
    component: EntryComponent,
    providers: [DynamicGalleryInitGuard],
    canActivate: [DynamicGalleryInitGuard]
  }
];
